import { getDate, getMonth, getYear, isValid } from 'date-fns';
import { FreeformMessage } from '../../generated/graphql';

type VirtualMessagingThreadFreeFormMessageItem = {
  type: 'FreeformMessage';
  item: FreeformMessage;
};

type VirtualMessagingThreadDateDividerItem = {
  type: 'DateDivider';
  item: Date;
};

export type VirtualMessagingThreadItem =
  | VirtualMessagingThreadFreeFormMessageItem
  | VirtualMessagingThreadDateDividerItem;

export function setupVirtualMessagingThreadItems(messages: FreeformMessage[]) {
  const sortedMessages = messages.sort(({ createdAt: cA1 }, { createdAt: cA2 }) => cA1.localeCompare(cA2));

  const map = new Map<string, FreeformMessage[]>();
  for (const message of sortedMessages) {
    if (!isValid(new Date(message.createdAt))) continue;
    const createdAt = new Date(message.createdAt);
    const createdAtSimple = new Date(getYear(createdAt), getMonth(createdAt), getDate(createdAt)).toISOString();
    const entries = map.get(createdAtSimple);
    if (!entries) {
      map.set(createdAtSimple, [message]);
    } else {
      map.set(createdAtSimple, [...entries, message]);
    }
  }

  return Array.from(map).reduce<VirtualMessagingThreadItem[]>(
    (prev, [dateString, msgs]) => [
      ...prev,
      {type: 'DateDivider', item: new Date(dateString)},
      ...msgs.map<VirtualMessagingThreadFreeFormMessageItem>((m) => ({type: 'FreeformMessage', item: m})),
    ],
    []
  );
}
